import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faH1 } from '@fortawesome/pro-light-svg-icons';

export type ProLightH1Props = IconComponentProps;

export const ProLightH1 = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightH1Props) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faH1}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faH1}
    />
  );
};

ProLightH1.displayName = 'ProLightH1';
